import {Http} from "oca-lib-web";

export default class AppReviewDataAccess {

    public static APPREVIEWS = "appReviews";

    public data:Array<any> = [];

    public fetchData(dataSource:DataSource, timeInterval:TimeInterval):any {
        var self = this;
        return new Promise(async function(resolve) {
            let params = JSON.parse(dataSource.params);
            let appReviews = "https://itunes.apple.com/rss/customerreviews/id=" + params.appleAppId + "/json";
            //console.log(appReviews);
            let results = await Http.getContents(appReviews);
            //console.log(results);
            let json = JSON.parse(results);
            console.log(json);
            let entries = json["feed"]["entry"];
            if (!entries) {
                resolve(false);
            } else {
                for (let entry of entries) {
                    let title = entry["title"]["label"]
                    let content = entry["content"]["label"];
                    let rating = entry["im:rating"]["label"];
                    let version = entry["im:version"]["label"]
                    let voteCount = entry["im:voteCount"]["label"];
                    let voteSum = entry["im:voteSum"]["label"];

                    self.data.push({
                        title: title,
                        content: content,
                        rating: rating,
                        version: version,
                        voteCount: voteCount,
                        voteSum: voteSum
                    })
                }
                console.log(self.data);

                resolve(self.data);
            }
        });
    }

    public clearData() {
        this.data = [];
    }
}